import React, {useEffect, useState} from "react";
import Label from "./Label";
import {UIModelAPI} from "../../types/api.types";
import {fetchUIModelsApi} from "../../services/ApiHelper";

type PromotionUIModelProps = {
    id?: string;
    projectId: string
    projectName: string;
    onClose: () => void;
    onSuccess: (ids: string[]) => void;
}

const PromotionUIModel = ({id, projectId, projectName, onClose, onSuccess}: PromotionUIModelProps) => {
    const baseId = id || 'promotion-ui-model';

    const [loading, setLoading] = useState(false);
    const [models, setModels] = useState<UIModelAPI[]>([]);
    const [selectedModel, setSelectedModel] = useState<string>('');

    useEffect(() => {
        fetchModels()
    }, []);

    const fetchModels = async () => {
        setLoading(true);
        try {
            const responseData = await fetchUIModelsApi(projectId, {pageNumber: 1, pageSize: 100}, 'name', 'asc', '');
            if (responseData?.done) {
                setModels(responseData.data.models);
                const promotedModel = responseData.data.models.find((model: any) => model.is_promoted);
                if(promotedModel) {
                    setSelectedModel(promotedModel.id);
                }
            }
        } catch (error) {
            // Handle error
        } finally {
            setLoading(false);
        }
    }

    const handleModelChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedModel(event.target.value);
    };

    return (
        <div id={baseId} data-testid={baseId} className='tw-w-[402px] tw-py-[12px] tw-px-[20px] tw-space-y-[16px]'>
            <div id={`${baseId}-model-section`} className='tw-space-y-[6px]'>
                <Label id={`${baseId}-model-label`} text={'Model'}/>
                <div id={`${baseId}-model-name`} className="tw-justify-start tw-text-black tw-text-lg tw-font-normal tw-font-['Noto_Sans'] tw-leading-relaxed">
                    {projectName}
                </div>
            </div>

            <div id={`${baseId}-ui-model-section`} className="tw-space-y-[6px]">
                <Label id={`${baseId}-ui-model-label`} text="UI Model"/>

                {loading ? (
                    <div className="tw-flex tw-items-center tw-justify-start tw-p-4 tw-border tw-border-shades-of-grey-30 tw-rounded">
                        <div className="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-b-2 tw-border-gray-900"/>
                        <span className="tw-ml-2 tw-text-gray-600">Loading models...</span>
                    </div>
                ) : (
                    <select
                        id={`${baseId}-ui-model-select`}
                        data-testid={`${baseId}-ui-model-select`}
                        value={selectedModel}
                        onChange={handleModelChange}
                        className="drop-down-dm tw-w-full tw-p-2"
                        disabled={models.length === 0}
                    >
                        {models.length === 0 ? (
                            <option value="">No UI models available</option>
                        ) : (
                            <>
                                <option value="">Select UI model</option>
                                {models.map((model) => (
                                    <option key={model.id} value={model.id}>
                                        {model.name}
                                    </option>
                                ))}
                            </>
                        )}
                    </select>
                )}
            </div>

            <div id={`${baseId}-actions`} className='tw-flex tw-gap-2 tw-justify-end tw-py-[14px]'>
                <button
                    id={`${baseId}-cancel-btn`}
                    data-testid={`${baseId}-cancel-btn`}
                    className='popup-button-outline'
                    onClick={onClose}
                >
                    Cancel
                </button>
                <button
                    id={`${baseId}-promote-btn`}
                    data-testid={`${baseId}-promote-btn`}
                    disabled={loading}
                    onClick={async () => onSuccess(selectedModel.length > 0 ? [selectedModel] : [])}
                    className='popup-button-filled'
                >
                    {loading ? 'Please wait...' : 'Promote'}
                </button>
            </div>
        </div>
    );
}

export default PromotionUIModel;